<template>
  <div class="content-box">
    <HconTitle subTitle="홈페이지 이용가이드" subDescription="Hcon 가입부터 구매·결제까지 한눈에 알기 쉽게 안내합니다."/>
    <!-- tab 카테고리(회원가입하기, 구매하기, 결제하기)-->
    <div class="tab-area v1 mt60">
      <ul class="tab-list">
        <li v-for="(item, idx) in guideTabData.v1.items" 
          :key="idx"
          class="tab-item" 
          :class="{active: guideTabData.v1.activeIndex === idx}">
          <button class="tab-btn" @click="handleTabClick('v1', idx)">
            <span class="tab-text">{{item.text}}</span>
          </button>
        </li>
      </ul>
    </div>
    <div class="tab-wrap">
      <!-- 홈페이지 이용가이드 - 회원가입하기 -->
      <div class="tab-pannel" v-if="guideTabData.v1.activeIndex === 0">
        <div class="guide-intro intro01">
          <div class="intro-text">
            <h3 class="guide-title">회원가입하기</h3>
            <p class="guide-desc">Hcon 서비스 가입하고 <strong class="text-green">기업 복지와 마케팅을 한 번에 해결</strong>하자!</p>
            <ul class="guide-info">
              <li>다양한 이벤트와 프로모션을 진행할 때, 임직원 복지용 대량 쿠폰 발송이 필요할 때</li>
              <li>복잡한 결제 없이 한 번 충전으로 바로 사용하고 싶을 때</li>
              <li>쿠폰 관리부터 고객 응대까지, 간편하고 효율적인 운영이 필요할 때</li>
            </ul>
          </div>
          <div class="intro-image"><img src="@/assets/images/pc/sub-hcon/img-guide01.png" alt=""></div>
        </div>
        <div class="guide-content"><NuxtLink :to="isLoggedIn === true ? '' : '/pc/member/join'"><img src="@/assets/images/pc/sub-hcon/img-guide-sample1.jpg" alt=""></NuxtLink></div>
      </div>
      <!-- 홈페이지 이용가이드 - 구매하기 -->
      <div class="tab-pannel" v-if="guideTabData.v1.activeIndex === 1" >
        <div class="guide-intro">
          <div class="intro-text">
            <h3 class="guide-title">구매하기</h3>
            <p class="guide-desc">Hcon 서비스로 쿠폰을 <strong class="text-green">쉽고 빠르게 구매</strong>하자!</p>
            <ul class="guide-info">
              <li>필요한 쿠폰을 한 번에 선택하고 기업 예산에 맞게 효율적으로 구매할 때</li>
              <li>복잡한 절차 없이 바로 결제하고 즉시 발송하고 싶을 때</li>
              <li>여러 브랜드 쿠폰을 한 번에 관리하며 이용 내역을 투명하게 확인하고 싶을 때</li>
            </ul>
          </div>
          <div class="intro-image"><img src="@/assets/images/pc/sub-hcon/img-guide02.png" alt=""></div>
        </div>
        <div class="guide-content"><NuxtLink to="/pc/order/basket"><img src="@/assets/images/pc/sub-hcon/img-guide-sample2.jpg" alt=""></NuxtLink></div>
      </div>
      <!-- 홈페이지 이용가이드 - 결제하기 -->
      <div class="tab-pannel" v-if="guideTabData.v1.activeIndex === 2">
        <div class="guide-intro">
          <div class="intro-text">
            <h3 class="guide-title">결제하기</h3>
            <p class="guide-desc">Hcon 서비스 충전 결제로 <strong class="text-green">편리하고 안전하게</strong>!</p>
            <ul class="guide-info">
              <li>복잡한 절차 없이 한 번의 클릭으로 결제 완료</li>
              <li>기업 예산에 맞춘 결제수단 선택으로 효율적 운영</li>
              <li>결제 내역과 사용 현황을 한눈에 확인할 수 있을때</li>
            </ul>
          </div>
          <div class="intro-image"><img src="@/assets/images/pc/sub-hcon/img-guide03.png" alt=""></div>
        </div>
        <div class="guide-content"><NuxtLink to="/pc/order/temp-save"><img src="@/assets/images/pc/sub-hcon/img-guide-sample3.jpg" alt=""><img src="@/assets/images/pc/sub-hcon/img-guide-sample4.jpg" alt=""></NuxtLink></div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import HconTitle from '@/components/com/HconComPCTitle.vue'

// pc/etc/homepage-use-guide 브래드크럼 영역
definePageMeta({label:'홈페이지 이용가이드'})

// 전역 팝업 설정(로그인여부)
const {isLoggedIn} = usePopup()

const guideTabData = ref({
  v1: {
    items: [
        { text: '회원가입하기'},
        { text: '구매하기'},
        { text: '결제하기' },
    ],
    activeIndex: 0
  },
})

//탭 유형 
type TabVersion = 'v1';

// 탭 클릭 핸들러
const handleTabClick = (version: TabVersion, index: number) => {
  guideTabData.value[version].activeIndex = index;
};

</script>
<style lang="scss">
@use "@/assets/scss/pc/etc-hcon.scss" as *;
</style>